import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import useActiveFeatureFlags from './useActiveFeatureFlags';

const useSkipTokensByFeature = () => {
  const flags = useActiveFeatureFlags();

  const shouldSkip = (flag: FeatureFlagEnum) => {
    return flags.includes(flag) === false;
  };

  return {
    skipActions: shouldSkip(FeatureFlagEnum.Actions),
    skipAnalytics: shouldSkip(FeatureFlagEnum.Analytics),
    skipAuditLogs: shouldSkip(FeatureFlagEnum.AuditLogs),
    skipCompliance: shouldSkip(FeatureFlagEnum.Compliance),
    skipDocumentManagement: shouldSkip(FeatureFlagEnum.DocumentManagement),
    skipForms: shouldSkip(FeatureFlagEnum.Forms),
    skipJobHazardAnalysis: shouldSkip(FeatureFlagEnum.JobHazardAnalysis),
    skipSafetyEvents: shouldSkip(FeatureFlagEnum.SafetyEvents),
    skipToolboxTalks: shouldSkip(FeatureFlagEnum.ToolboxTalks),
    skipVendors: shouldSkip(FeatureFlagEnum.Vendors),
    skipWorkflows: shouldSkip(FeatureFlagEnum.Workflows),
    skipTraining: shouldSkip(FeatureFlagEnum.Training),
  };
};

export default useSkipTokensByFeature;
